import { Typography } from "@mui/material";
import React from "react";
import { theme } from "../../Common/UI/styles/theme";
import VendorRequestUpdatePicture1 from "../../img/VendorRequestUpdatePicture1.png";
import VendorRequestUpdatePicture2 from "../../img/VendorRequestUpdatePicture2.png";

const VendorSetupSOP: React.FC = () => {
  return (
    <>
      <Typography variant="h6" className="release-title" color={theme.palette.error.main}>
        Vendor Setup SOP
      </Typography>

      <ul>
        <li>
          <b>Step 1: Email Tax Documentation</b>
          <ul>
            <li>
              a. Email the required tax documents (e.g., <strong>signed</strong> W9, IRS letter) to
              <span className="font-semibold text-blue-600">
                {" "}
                <a href="mailto:vendorrequests@torchystacos.com" className="text-blue-600">
                  vendorrequests@torchystacos.com
                </a>
              </span>{" "}
              ✅
            </li>
            <li>
              b. ⚠ <strong>Use the EXACT Legal and, if needed, Vendor Name from Step 2</strong> in both the <strong>Subject Line</strong> and <strong>Email Body</strong> — this must match Step 2 to
              avoid delays.
            </li>
            <br />
            <div style={{ fontWeight: "bold", borderRadius: "4px" }}>
              ⚠ Vendor Requests CANNOT be processed without EMAILING the required tax documentation to:
              <span className="text-blue-600">
                {" "}
                <a href="mailto:vendorrequests@torchystacos.com" className="text-blue-600">
                  vendorrequests@torchystacos.com
                </a>
              </span>{" "}
              ✅
            </div>
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          <b>
            Step 2: Create a <span className="font-bold">Vendor Request Form (VRF)</span> by completing the{" "}
            <a
              href="https://4581182.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=753&deploy=2&compid=4581182&ns-at=AAEJ7tMQUmmh-BoQPLGRBb0epSfgTmKfo_RvEFcJxOfPJZrKkoI"
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 underline"
            >
              Vendor Request Link
            </a>
            . ✅
          </b>
          <ul>
            <li>a. Below is a screenshot of the VRF. Each line includes a brief description of the required information for each field.</li>
            <br />
            <div style={{ fontWeight: "bold", borderRadius: "4px" }}>
              ⚠ Ensure all fields are completed accurately to prevent processing delays. ⚠
              <br />
              <img src={VendorRequestUpdatePicture1} alt="VendorRequestUpdate" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
            </div>
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          <b>Additional Information</b>
          <ul>
            <li>
              <strong>Legal Name</strong> – name per W9/tax document
            </li>
            <li>
              <strong>Vendor Name</strong> – payable name, if different than Legal Name (e.g., DBA, PTO, Group, or Org Name)
            </li>
            <li>
              <strong>SSN/Federal Tax ID</strong> – Use the number as noted on the Tax Documentation submitted (W9, IRS Letter, etc.).
            </li>
            <br />
            <div className="font-semibold text-yellow-600">
              ⚠ <strong>NOTE</strong>: SN Events <strong>CANNOT</strong> use an SSN as the Tax ID Number. ⚠
            </div>
            <br />
            <li>
              <strong>Name of Torchy's Contact You Have Been Working With</strong> – the name of the requestor
            </li>
            <li>
              <strong>Email Address of Torchy's Contact You Have Been Working With</strong> – the email address of the requestor
            </li>
            <li>
              <strong>Payment Method</strong> – Select payment method as noted by the vendor (ACH or check). If the selected payment method is <strong>check</strong>, a physical check will be mailed
              to the <strong>legal address</strong>. To use a different address, complete the <strong>Payment Address</strong> section.
            </li>
            <br />
            <div className="font-semibold text-yellow-600">
              ⚠ <strong>NOTE</strong>: Payment Address instructions for different types of organizations. ⚠
            </div>
            <br />
            <li>
              <ul className="list-disc pl-6">
                <li>
                  <strong>PTA, PTO, School Clubs, Boosters, and Sports Teams:</strong> Send payments to the school's address only. Do not use district offices, personal, or third-party addresses.
                </li>
                <li>
                  <strong>Fraternities, Sororities, and College Groups:</strong> Send payments to the Greek house or the fundraising organization's address, not the school. Include a contact name
                  (C/O) if needed.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          <b>Vendor Address and Contact Information</b>
          <ul>
            <li>
              <strong>Address</strong> – vendor address as noted on the Tax Documentation submitted to{" "}
              <a href="mailto:vendorrequests@torchystacos.com" className="text-blue-600">
                vendorrequests@torchystacos.com
              </a>
            </li>
            <li>
              <strong>City</strong> – vendor city as noted on the Tax Documentation submitted to{" "}
              <a href="mailto:vendorrequests@torchystacos.com" className="text-blue-600">
                vendorrequests@torchystacos.com
              </a>
            </li>
            <li>
              <strong>State</strong> – vendor state as noted on the Tax Documentation submitted to{" "}
              <a href="mailto:vendorrequests@torchystacos.com" className="text-blue-600">
                vendorrequests@torchystacos.com
              </a>
            </li>
            <li>
              <strong>Zip Code</strong> – vendor zip code as noted on the Tax Documentation submitted to{" "}
              <a href="mailto:vendorrequests@torchystacos.com" className="text-blue-600">
                vendorrequests@torchystacos.com
              </a>
            </li>
            <li>
              <strong>Contact Name</strong> – the vendor representative requesting the spirit night
            </li>
            <li>
              <strong>Contact Phone</strong> – phone number of the vendor representative requesting the spirit night
            </li>
            <li>
              <strong>Contact Email</strong> – email of the vendor representative requesting the spirit night
            </li>
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          <b>Payment Information</b>
          <ul>
            <img src={VendorRequestUpdatePicture2} alt="VendorRequestUpdate" style={{ maxWidth: "100%", height: "auto", padding: "8px 0" }} />
            <li>
              <strong>Bank Name</strong> (ACH Only) – name of financial institution
            </li>
            <li>
              <strong>Account#</strong> (ACH Only) – account number
            </li>
            <li>
              <strong>Name on Account</strong> – Payable name
            </li>
            <li>
              <strong>Routing#</strong> (ACH Only) – routing number
            </li>
            <li>
              <strong>Email Address for ACH Payment Notification</strong> – vendor's email address to receive payment remittance
            </li>
            <li className="font-semibold text-yellow-600">⚠ For residential addresses, include the name of a contact person (C/O). ⚠</li>
            <li>
              <strong>Payment Address</strong> – vendor street number and name associated with payment remittance address i.e. address where the check will be mailed or address associated with bank
              account for ACH
            </li>
            <li>
              <strong>Payment City</strong> – vendor city associated with payment remittance address i.e. address where the check will be mailed or address associated with bank account for ACH
            </li>
            <li>
              <strong>Payment State</strong> – vendor state associated with payment remittance address i.e. address where the check will be mailed or address associated with bank account for ACH
            </li>
            <li>
              <strong>Payment Zip</strong> – vendor zip code associated with payment remittance address i.e. address where the check will be mailed or address associated with bank account for ACH
            </li>
            <br />
            <div style={{ fontWeight: "bold", borderRadius: "4px", fontStyle: "italic" }}>
              Once all required fields are completed, click submit. The vendor request is then added to the queue for review, which can take 7-10 business days.
            </div>
            <br />
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          <b>Step 3: Vendor approved by Marker Partner</b>
          <ul>
            <li>
              a. Once <strong>Step 1 and Step 2</strong> are reviewed, an email containing the vendor request approval will be sent to the <strong>Market Partner</strong> of the requestor. The vendor
              will then be reviewed and approved by the <strong>Market Partner</strong>, after which the vendor will be <strong>activated in NetSuite</strong>.
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
};

export default VendorSetupSOP;
